import { useQuery } from 'react-query';
import { loadWifiThermostatDetails } from '../services/wifiThermostats';
import { WifiSeamThermostat } from '../redux/types/wifiThermostats';

export const useGetSeamWifiThermostat = (id: string | null) => useQuery<WifiSeamThermostat>(
  ['useGetSeamWifiThermostat', id],
  () => loadWifiThermostatDetails(id as string)
    .then((res) => res.data),
  {
    enabled: !!id,
    refetchOnWindowFocus: false,
  },
);
